module.exports = __webpack_public_path__ + "src/app/_content/MOTFonts/BMWMotorradOutlineW01-Rg.woff2?07619b1912b9773c8e30fd762b6e113e";